import { createFileRoute } from '@tanstack/react-router'
import PageWelcomeBack from '@/pages/account/welcome-back'

export const Route = createFileRoute('/app/account/welcome-back')({
  component: RouteComponent,
})

function RouteComponent() {
  return <PageWelcomeBack />
}
